import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { X } from 'lucide-react';
import ContactSection from '../home/ContactSection';

/*
 * Contact modal: lets the detail-page CTAs open the exact homepage Contact
 * section in a popup instead of navigating away. Provider renders the overlay;
 * useContactModal().openContact() opens it. Body scroll locks; Esc closes.
 */
const Ctx = createContext({ openContact: () => {}, closeContact: () => {} });
export const useContactModal = () => useContext(Ctx);

export function ContactModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openContact = useCallback(() => setOpen(true), []);
  const closeContact = useCallback(() => setOpen(false), []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    if (open) window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <Ctx.Provider value={{ openContact, closeContact }}>
      {children}
      {open && (
        <div className="cmodal" onClick={closeContact} role="dialog" aria-modal="true" aria-label="Contact us">
          <div className="cmodal__card" onClick={(e) => e.stopPropagation()}>
            <button className="cmodal__close" onClick={closeContact} aria-label="Close">
              <X size={22} />
            </button>
            <ContactSection embedded />
          </div>
        </div>
      )}
    </Ctx.Provider>
  );
}
